const validations = {
	'required': () => ( import('./required') ),
	'email': () => ( import('./email') ),
	'fullName': () => ( import('./full-name') ),
	'text': () => ( import('./text') ),
	'date': () => ( import('./date') ),
	'citizenId': () => ( import('./citizen-id') ),
	'taxOrCitizenId': () => ( import('./tax-or-citizen-id') ),
	'phone': () => ( import('./phone') ),
	'minNum': () => ( import('./min-num') ),
	'maxNum': () => ( import('./max-num') ),
	'length': () => ( import('./length') ),
	'minLength': () => ( import('./min-length') ),
	'maxLength': () => ( import('./max-length') ),
	'minWords': () => ( import('./min-words') ),
	'maxWords': () => ( import('./max-words') ),
	'compareValue': () => ( import('./compare-value') ),
	'cardNumber': () => ( import('./card-number') ),
	'cardCvv': () => ( import('./card-cvv') ),
	'cardExpiry': () => ( import('./card-expiry') ),
	'includesNumber': () => ( import('./includes-number') ),
	'includesUppercaseLetter': () => ( import('./includes-uppercase-letter') ),
	'includesLowercaseLetter': () => ( import('./includes-lowercase-letter') ),
	'specialCharacters': () => ( import('./special-characters') ),
}

export default validations;